import * as Actions from './AssumptionsActions';

const initialState = {
  Assumptions: [],
  CorrelationMatrix: [],
  isAdviserArea: null,
};

const AssumptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.INITIALIZE_SECTION:
      return {
        ...state,
        isAdviserArea: action.isAdviserArea,
      };
    case Actions.RESET_SECTION:
      return initialState;
    case Actions.RECEIVE_DATA:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export default AssumptionsReducer;
